'use strict';
var React = require('react');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
var PathData = require('../../helper/PathData');
var graphicsHelper = require('../../helper/graphicsHelper');
/*
 * 涂鸦板组件
 */
var Graffiti = React.createClass({

  // TODO: 该组件还存在一些绘制问题，需要重新对坐标点进行计算。

  render: function () {
    var boxStyle = {
      width: styleHelper.getWidth(this.props),
      height: styleHelper.getHeight(this.props),
      overflow: 'hidden'
    };
    return (
      <div style={boxStyle}>
          <canvas
            ref="canvas"
            style={{
                      width : '100%',
                      height : '100%'
                  }}
            width={styleHelper.getWidth(this.props)}
            height={styleHelper.getHeight(this.props)}
          />
      </div>
    );
  },

  componentDidUpdate: function () {
    this.paint();
  },
  componentDidMount: function () {
    this.pathData = new PathData();
    this.pathData.parseData(this.props.pointList);
    var bound = this.pathData.getBounds();
    var dom = ReactDOM.findDOMNode(this.refs.canvas);
    var w = Math.max(bound.width,styleHelper.getWidth(this.props));
    var h = Math.max(bound.height,styleHelper.getHeight(this.props));
    //$(dom).css({left : 0,top:0,width:w,height:h});
    dom.width = w;
    dom.height = h;
    this.paint();
  },

  paint: function () {
    var params = {
      thickness : this.props.strokeThickness,
      borderColor : styleHelper.getBackgroundColor(this.props)
    };
    var ctx = ReactDOM.findDOMNode(this.refs.canvas).getContext('2d');
    var ratio = graphicsHelper.applyDeviceRatio(ctx,styleHelper.getWidth(this.props),styleHelper.getHeight(this.props));
    graphicsHelper.drawPath(ctx,this.pathData,params,ratio);
  }

});

module.exports = Graffiti;



// WEBPACK FOOTER //
// ./src/views/Components/Graffiti.jsx